import { useRef, useState, useEffect } from "react";
import New from "../components/nouveaute/nouveaute";

const START_OFFSET = 2;

export default function Main() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (isPlaying) {
      v.pause();
      setIsPlaying(false);
    } else {
      v.play();
      setIsPlaying(true);
    }
  };

  const handleLoadedMetadata = () => {
    const v = videoRef.current;
    if (!v) return;
    const target = Math.max(0, v.duration - START_OFFSET);
    v.currentTime = target;
    v.play()
      .then(() => setIsPlaying(true))
      .catch(() => {});
  };

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && !v.paused) {
          v.pause();
          setIsPlaying(false);
        }
      },
      { threshold: 0.1 }
    );
    io.observe(v);
    return () => io.disconnect();
  }, []);

  return (
    <div className="grid gap-y-6">
      <div className="relative min-h-screen overflow-hidden">
        <img
          src="/images/uniquepiece/espoir/2.jpg"
          alt="Visuel SAME"
          className="block md:hidden absolute top-0 left-0 w-full h-full object-cover z-0"
          loading="lazy"
        />

        <video
          ref={videoRef}
          preload="metadata"
          muted
          loop
          playsInline
          onLoadedMetadata={handleLoadedMetadata}
          className="hidden md:block absolute top-0 left-0 w-full h-full object-cover z-0"
          poster="/images/home/poster.jpg"
        >
          <source src="/images/home/homepagevideo.mp4" type="video/mp4" />
          Votre navigateur ne supporte pas la vidéo.
        </video>

        <button
          onClick={togglePlay}
          title="Mettre en pause ou jouer la vidéo"
          className="hidden md:block absolute top-6 right-6 z-10 bg-black text-white px-4 py-2 rounded-md text-sm hover:bg-black transition"
        >
          {isPlaying ? "Pause" : "Play"}
        </button>
      </div>

      <div className="h-full mt-2">
        <New />
      </div>
    </div>
  );
}
